const PauseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.6 2.40039C4.26863 2.40039 4 2.66902 4 3.00039V13.0004C4 13.3318 4.26863 13.6004 4.6 13.6004H5.8C6.13137 13.6004 6.4 13.3318 6.4 13.0004V3.00039C6.4 2.66902 6.13137 2.40039 5.8 2.40039H4.6Z"
        fill="#07070C"
      />
      <path
        d="M10.2 2.40039C9.86863 2.40039 9.6 2.66902 9.6 3.00039V13.0004C9.6 13.3318 9.86863 13.6004 10.2 13.6004H11.4C11.7314 13.6004 12 13.3318 12 13.0004V3.00039C12 2.66902 11.7314 2.40039 11.4 2.40039H10.2Z"
        fill="#07070C"
      />
    </svg>
  );
};

export default PauseIcon;
